<template>
  <div class="k-menu">
    <ul class="list">
      <li class="item -active">
        clube
      </li>
      <li class="item">
        <a
          target="_blank"
          :href="storeLink"
          @click="handleAnalytics"
        >
          store
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TopMenu',
  props: {
    companySlug: String,
    hasMarketplace: String
  },
  computed: {
    storeLink () {
      const marketplace = (this.hasMarketplace && this.hasMarketplace.length > 0) ? this.hasMarketplace : ''
      return `https://store.kaledo.com.br/${marketplace}?utm_source=kaledo&utm_campaign=${this.companySlug}`
    }
  },
  methods: {
    handleAnalytics () {
      window.dataLayer.push(
        {
          event: 'kaledo-store'
        })
    }
  }
}
</script>

<style lang='scss' scoped>
@import '~@style/reference';

.k-menu {
  max-width: 992px;
  margin-left: auto;
  margin-right: auto;
  -webkit-box-orient: horizontal;
  >.list {
    list-style: none;
    display: flex;
    font-size: 14px;
    >.item {
      padding: 7px 42px;
      color: $base-color;
      border-bottom: 3px solid white;
      font-family: $title-font-family;
      font-weight: 500;
      transition: all ease 0.3s;
      &:hover{
        border-color: $gray;
      }
      &.-active {
        border-color: var(--color-primary);
      }
      a {
        text-decoration: none;
        color: $base-color;
      }
      @include mobile {
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/TopMenu.vue